export const theme = {
  primaryColor: "#03796E",
  secondaryColor: "#8D7200",
  BackgroundColor: "#F8FCFC",

  carbsColor: "#228B22",
  proteinColor: "#7B61FF",
  fatColor: "#CC5500",
  fibreColor: "#DA9D42",

  textColor: "#020C0B",
  H1: "30px",
  primaryRadius: "16px",
  SecondaryRadius: "8px",
  regular: 400,
  medium: 600,
  bold: 800,

};


const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px'
}

export const device = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`
};